export const GET_SUBSCRIPTIONS_PENDING = "GET_SUBSCRIPTIONS_PENDING";
export const GET_SUBSCRIPTIONS_ERROR = "GET_SUBSCRIPTIONS_ERROR";
export const GET_SUBSCRIPTIONS_SUCCESS = "GET_SUBSCRIPTIONS_SUCCESS";

export const CHECKOUT_SUBSCRIPTIONS_PENDING = "CHECKOUT_SUBSCRIPTIONS_PENDING";
export const CHECKOUT_SUBSCRIPTIONS_ERROR = "CHECKOUT_SUBSCRIPTIONS_ERROR";
export const CHECKOUT_SUBSCRIPTIONS_SUCCESS = "CHECKOUT_SUBSCRIPTIONS_SUCCESS";

export function getSubscriptionsPending() {
  return { type: GET_SUBSCRIPTIONS_PENDING };
}

export function getSubscriptionsSuccess(payload) {
  return { type: GET_SUBSCRIPTIONS_SUCCESS, payload };
}

export function getSubscriptionsError(error) {
  return { type: GET_SUBSCRIPTIONS_ERROR, error };
}

export function checkoutSubscriptionPending() {
  return { type: CHECKOUT_SUBSCRIPTIONS_PENDING };
}

export function checkoutSubscriptionsSuccess(payload) {
  return { type: CHECKOUT_SUBSCRIPTIONS_SUCCESS, payload };
}

export function checkoutSubscriptionsError(error) {
  return { type: CHECKOUT_SUBSCRIPTIONS_ERROR, error };
}
